import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  notificationsRedirectURL: {
    '&:hover': {
      color: `${token.colorInfo} !important`
    }
  },
  text: {
    color: 'inherit'
  },

  notificationList: {
    display: 'grid',
    maxHeight: 535,
    overflowY: 'auto'
  }
}))
